import { useAppSelector } from "store";
import { UserAreaName } from "types/user.types";

export const useHasUserArea = (possibleAreas: UserAreaName[]) => {
    const userAreas = useAppSelector((state) => state.user.areas);
    return possibleAreas.some((possibleArea) => userAreas.includes(possibleArea));
};
